"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ExclamationMarkTriangle42Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 42, height: 42, viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.7688 6.35135C22.0183 4.92937 19.9817 4.92937 19.2312 6.35135L3.54823 36.0665C2.84528 37.3984 3.81098 39 5.31701 39H36.683C38.189 39 39.1547 37.3984 38.4517 36.0665L22.7688 6.35135ZM21 7.28487L36.683 37H5.317L21 7.28487ZM20 17H22V26H20V17ZM21 33C22.1046 33 23 32.1046 23 31C23 29.8954 22.1046 29 21 29C19.8954 29 19 29.8954 19 31C19 32.1046 19.8954 33 21 33Z", fill: "#383F49" }));
}
function ExclamationMarkTriangle42(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ExclamationMarkTriangle42Svg, Object.assign({}, svgProps)));
}
exports.default = ExclamationMarkTriangle42;
//# sourceMappingURL=ExclamationMarkTriangle42.js.map